// src/components/AdminHome.jsx
import React, { useEffect, useState } from "react";
import "./adminHome.css"; // IMPORTANT: use same CSS as Business
import { supabase } from "../../supabase_client.jsx";
import uscImage from "../../assets/usc.jpg";

export default function AdminHome({ currentUser, onViewSelect }) {
  const [username, setUsername] = useState("");
  const [kpis, setKpis] = useState({
    totalUsers: 0,
    totalEvents: 0,
    pendingEvents: 0,
    openReports: 0,
  });

  const [animatedKpis, setAnimatedKpis] = useState({
    totalUsers: 0,
    totalEvents: 0,
    pendingEvents: 0,
    openReports: 0,
  });

  const [events, setEvents] = useState([]);
  const userId = currentUser?.user?.id;

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      const { data: userData } = await supabase
        .from("users")
        .select("username")
        .eq("user_id", userId)
        .single();

      if (userData?.username) setUsername(userData.username);

      const { count: totalUsers } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true });

      const { count: totalEvents } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true });

      const { count: pendingEvents } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true })
        .eq("is_approved", false);

      const { count: reportedUsersCount } = await supabase
        .from("users")
        .select("*", { count: "exact", head: true })
        .eq("is_reported", true);

      const { count: reportedEventsCount } = await supabase
        .from("events")
        .select("*", { count: "exact", head: true })
        .eq("is_reported", true);

      const openReports =
        (reportedUsersCount || 0) +
        (reportedEventsCount || 0);

      setKpis({
        totalUsers: totalUsers || 0,
        totalEvents: totalEvents || 0,
        pendingEvents: pendingEvents || 0,
        openReports: openReports || 0,
      });

      const { data: upcomingData } = await supabase
        .from("events")
        .select("*")
        .gte("date", new Date().toISOString())
        .order("date", { ascending: true });

      setEvents(upcomingData || []);
    };

    fetchData();
  }, [userId]);

  useEffect(() => {
    const duration = 800;
    const steps = 30;
    const interval = duration / steps;

    Object.keys(kpis).forEach((key) => {
      let start = 0;
      const end = kpis[key];
      const increment = end / steps;

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(timer);
        }

        setAnimatedKpis((prev) => ({
          ...prev,
          [key]: Math.floor(start),
        }));
      }, interval);
    });
  }, [kpis]);

  return (
    <div className="home-container">
      <div className="home-card">
        <div className="admin-home">

      {/* NAV */}
      <div className="calendar-top-nav">
        <div className="nav-left">
          <button className="nav-tab active" onClick={() => onViewSelect("admin")}>
            General
          </button>
          <button className="nav-tab" onClick={() => onViewSelect("adminCalendar")}>
            Event Calendar
          </button>
          <button className="nav-tab" onClick={() => onViewSelect("adminKPIDash")}>
            KPI Dashboard
          </button>
          <button className="nav-tab" onClick={() => onViewSelect("adminEventManagement")}>
            Event Management
          </button>
          <button className="nav-tab" onClick={() => onViewSelect("user-management")}>
            User Management
          </button>
          <button className="nav-tab" onClick={() => onViewSelect("business-management")}>
            Business Management
          </button>
          <button className="bpActionBtn secondary" onClick={() => {
            sessionStorage.removeItem("currentUser");
            sessionStorage.removeItem("currentView");
            onViewSelect("loginSignup");
          }}>
            Log Out
          </button>
        </div>
      </div>

          <div className="overlap-section">
            <img src={uscImage} alt="usc" className="detail-image" />
            <div className="welcome-card">
              <h1 className="home-title">Welcome Back, {username || "..."}!</h1>
              <p className="welcome-subtitle">Here’s what’s happening across your entire platform.</p>
            </div>
          </div>

          {/* HEADER */}
          <div className="dashboard-header">
            <div>
              <h1>Platform Snapshot</h1>
            </div>

            <button
              className="primary-btn"
              onClick={() => onViewSelect("adminEventManagement")}
            >
              Review Events
            </button>
          </div>

          <div className="kpi-grid">

            <div className="kpi-card">
              <h3>{animatedKpis.totalUsers}</h3>
              <p>Total Users</p>
            </div>

            <div className="kpi-card">
              <h3>{animatedKpis.totalEvents}</h3>
              <p>Total Events</p>
            </div>

            <div className="kpi-card">
              <h3>{animatedKpis.pendingEvents}</h3>
              <p>Pending Approvals</p>
            </div>

            <div className="kpi-card">
              <h3>{animatedKpis.openReports}</h3>
              <p>Open Reports</p>
            </div>

          </div>

          <div className="section-card">
            <div className="section-header">
              <h2>Upcoming Events</h2>
              <button
                className="link-btn"
                onClick={() => onViewSelect("adminCalendar")}
              >
                View Calendar →
              </button>
            </div>

            {events
              ?.filter((event) => {
                const eventDate = new Date(event.date);
                const now = new Date();
                const nextWeek = new Date();
                nextWeek.setDate(now.getDate() + 7);
                return eventDate >= now && eventDate <= nextWeek;
              })
              .slice(0, 5)
              .length === 0 ? (
                <p className="empty-state">No upcoming events.</p>
              ) : (
                events
                  ?.filter((event) => {
                    const eventDate = new Date(event.date);
                    const now = new Date();
                    const nextWeek = new Date();
                    nextWeek.setDate(now.getDate() + 7);
                    return eventDate >= now && eventDate <= nextWeek;
                  })
                  .slice(0, 5)
                  .map((event) => (
                    <div key={event.id} className="event-item no-click">
                      <div className="event-text">
                        <span className="event-name">{event.name}</span>
                        <span className="event-date">{event.date}</span>
                      </div>
                    </div>
                  ))
              )}
          </div>

          <div className="quick-actions">

            <div
              className="action-card"
              onClick={() => onViewSelect("adminCalendar")}
            >
              Calendar
            </div>

            <div
              className="action-card"
              onClick={() => onViewSelect("adminKPIDash")}
            >
              Analytics
            </div>

            <div
              className="action-card"
              onClick={() => onViewSelect("user-management")}
            >
              User Management
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}